/**
 * Blockchain Contract state Enum
 */
export const ContractState = {
    NOT_INITIATED: 0,
    AWAITING_PAYMENT: 1,
    AWAITING_WORKCOMPLETION: 2,
    COMPLETE: 3,
    PARTIES_DISAGREE: 4,
    AWAITING_NEW_OFFER: 5
}